// hooks/useScrollAnimation.js
import { useEffect } from "react";

export default function useScrollAnimation() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    const targetElements = document.querySelectorAll(".animate-on-scroll");
    targetElements.forEach((element) => observer.observe(element));

    return () => targetElements.forEach((element) => observer.unobserve(element));
  }, []);
}